
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-index",
      function () {
        return require("private-next-pages/special-index/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special-index"])
      });
    }
  